import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorOverlayService } from '../../services/overlay.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';


@Component({
  selector: 'app-error-overlay',
  templateUrl: './error-overlay.component.html',
  styleUrls: ['./error-overlay.component.scss']
})
export class ErrorOverlayComponent implements OnInit, OnDestroy {
  @Input() isVisible: boolean = false;
  @Input() message: string = '';
  @Input() title: string = '';
  @Output() logout = new EventEmitter<void>();

  private subscription?: Subscription;

  constructor(private errorOverlayService: ErrorOverlayService, private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    
    this.subscription = this.errorOverlayService.overlay$.subscribe(state => {
      
      this.isVisible = state.isVisible;
      
      if (state.data) {
        this.message = state.data.message;
        this.title = state.data.title || '';
      } else {
        this.message = '';
        this.title = '';
      }
    });

    const currentState = this.errorOverlayService.isOverlayVisible();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onLogout() {
    this.logout.emit();
    this.errorOverlayService.hideOverlay();
    this.authenticationService.logout();
  }

  testShow() {
    this.errorOverlayService.showCompanyOverlay('Test message from component');
  }
}